import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  periodSelector: {
    '& .MuiSelect-root': {
      color: 'black',
      margin: 0,
    },
  },
}));

interface PeriodSelectorProps {
  value: string | number;
  onChange: (value: string | number) => void;
}

export const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  value,
  onChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handlePeriodChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string | number);
  };

  // Generate year options
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 3 }, (_, i) => currentYear - i);

  return (
    <FormControl variant="outlined" className={classes.periodSelector}>
      <Typography
        variant="body1"
        style={{ marginRight: 16, color: 'black' }}
      >
        {t('Period')}
      </Typography>
      <Select
        value={value}
        onChange={handlePeriodChange}
        style={{ color: 'black', minWidth: 150, maxHeight: 40 }}
      >
        <MenuItem value="last-12-months" style={{ color: 'black' }}>
          {t('Last 12 Months')}
        </MenuItem>
        <MenuItem value="last-24-months" style={{ color: 'black' }}>
          {t('Last 24 Months')}
        </MenuItem>
        <MenuItem disabled style={{ color: 'gray', fontSize: '0.8em' }}>
          {t('By Year')}
        </MenuItem>
        {yearOptions.map((year) => (
          <MenuItem key={year} value={`year-${year}`} style={{ color: 'black' }}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PeriodSelector;